import { query_product_out_cancel_record_list } from '@/api/mjstock-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstock/mjstock-productoutcancelrecord-config';
import { reactive } from 'vue';
import { get_is_active, getDateTime, toFixed0 } from '@/utils/function';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'code',
        label: '出库退货单编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写出库退货单编号',
      },
      {
        type: 'remotemodal',
        name: 's_product_id',
        label: '存货名称',
        disabled: false,
        placeholder: '请选择产品',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstock-sproduct',
      },
      {
        type: 'remotemodal',
        name: 'order_used_record_id',
        label: '关联耗单',
        disabled: false,
        labelKey: 'order_code',
        placeholder: '请选择关联耗单',
        datasourceType: 'remote',
        mode: 'default',
        init_model: { shop_id: current_shop?.id },
        field_status: { shop_id: current_shop ? 0 : 2 },
        allowClear: true,
        modalType: 'mjstore-orderusedrecord',
      },
      {
        type: 'remotemodal',
        name: 'order_used_cancel_record_id',
        label: '关联耗单退单',
        disabled: false,
        placeholder: '请选择关联耗单退单',
        datasourceType: 'remote',
        mode: 'default',
        labelKey: 'order_code',
        allowClear: true,
        modalType: 'mjstore-orderusedcancelrecord',
      },
      {
        type: 'remotemodal',
        name: 'product_out_record_id',
        label: '关联出库单',
        disabled: false,
        placeholder: '请选择关联出库单',
        datasourceType: 'remote',
        labelKey: 'code',
        init_model: { shop_id: current_shop?.id },
        field_status: { shop_id: current_shop ? 0 : 2 },
        mode: 'default',
        allowClear: true,
        modalType: 'mjstock-productoutrecord',
      },
      {
        type: 'remotemodal',
        name: 'transfer_shop_id',
        label: '调拨去向',
        disabled: false,
        placeholder: '请选择调拨去向',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'input',
        name: 'transfer_code',
        label: '调拨编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写调拨编号',
      },
      {
        type: 'input',
        name: 'transfer_cancel_code',
        label: '调拨退货编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写调拨退货编号',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '执行门店',
        disabled: !!current_shop,
        placeholder: '请选择执行门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'remoteselect',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      code: null,
      s_product_id: null,
      order_used_record_id: null,
      order_used_cancel_record_id: null,
      product_out_record_id: null,
      transfer_shop_id: null,
      transfer_code: null,
      transfer_cancel_code: null,
      shop_id: current_shop?.id,
      staff_id: null,
    }),
  };
  const search_options = {
    is_active: [
      { value: None, name: '全部' },
      { value: True, name: '可用' },
      { value: False, name: '作废' },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '存货出库退货记录管理',
    addModalTitle: '新建存货出库退货记录',
    updateTitle: '修改存货出库退货记录',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },

    {
      title: '出库退货单号',
      width: 190,
      dataIndex: 'code',
      fixed: 'left',
      checked: true,
    },
    {
      title: '关联出库单编号',
      width: 190,
      dataIndex: 'product_out_record__code',
      checked: true,
    },
    {
      title: '关联入库单号',
      width: 190,
      dataIndex: 'product_out_record__product_in_record_code',
      checked: true,
    },
    {
      title: '关联耗单编号',
      width: 190,
      dataIndex: 'order_used_record__order_code',
      checked: true,
    },
    {
      title: '存货编码',
      width: 150,
      dataIndex: 's_product__code',
      checked: true,
    },
    {
      title: '存货名称',
      width: 150,
      dataIndex: 's_product__name',
      checked: true,
    },
    {
      title: '存货名称',
      width: 150,
      dataIndex: 's_product__gg',
      checked: true,
    },
    {
      title: '存货单位',
      width: 150,
      dataIndex: 's_product__dw',
      checked: true,
    },

    {
      title: '退货数量',
      width: 150,
      dataIndex: 'cancel_num',
      checked: true,
    },
    {
      title: '退货单价',
      width: 150,
      dataIndex: 'single_price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '退货金额',
      width: 150,
      dataIndex: 'price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '退货原因',
      width: 150,
      dataIndex: 'cancel_reason',
      checked: true,
    },
    {
      title: '退货日期',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '调拨去向',
      width: 150,
      dataIndex: 'transfer_shop__name',
      checked: true,
    },
    {
      title: '调拨编号',
      width: 150,
      dataIndex: 'transfer_code',
      checked: true,
    },
    {
      title: '调拨退货编号',
      width: 150,
      dataIndex: 'transfer_cancel_code',
      checked: true,
    },
    {
      title: '是否确认入库',
      width: 150,
      dataIndex: 'confirm_in_stock',
      checked: true,
      cellComponent: 'boolean',
      name1: '已入库',
      name2: '未入库',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '已入库', value: true },
        { text: '未入库', value: false },
      ],
      content: (record: any, text: any) => {
        const dict: any = {
          true: '已入库',
          false: '未入库',
        };
        return dict[text];
      },
    },
    {
      title: '执行门店',
      width: 150,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '执行人',
      width: 150,
      dataIndex: 'staff__name',
      checked: true,
    },

    {
      title: '单据状态',
      width: 150,
      dataIndex: 'is_active',
      checked: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '作废',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: true },
        { text: '作废', value: false },
      ],
      content: (record: any, text: any) => {
        return get_is_active(text);
      },
    },
    {
      title: '操作',
      width: 200,
      dataIndex: 'action',
      checked: true,
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push(
    {
      type: 'custom',
      slotName: 'is_active',
      field_true: '可用',
      field_false: '作废',
    },
    {
      type: 'custom',
      slotName: 'confirm_in_stock',
      field_true: '已入库',
      field_false: '未入库',
    },
  );

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_product_out_cancel_record_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
